import React from 'react'
import '../index.css';
function Footer()
{
    return (
        <div className="footer">
            <p>Designed with Love by Shefali </p>
            <h5 >  Copyright 2022 © shefali</h5>
            <a href="https://github.com/shefali12-ab"><i class="fa fa-github footericon"></i> </a>
            <a href="https://www.linkedin.com/in/shefalik16/"><i class="fab fa-linkedin footericon"></i></a>
            <a href="https://twitter.com/shefali_kanojia"><i class="fab fa-twitter footericon"></i></a>
            
            

           
        </div>
    )
}
export default Footer;
